<template>
  <rir-input
    v-if="field.dataType === 'string'"
    :label="field.name"
    v-model="field.value"
    :readonly="isRead"
    />
  <rir-date-picker
    v-else-if="field.dataType === 'date'"
    :label="field.name"
    v-model="field.value"
    :readonly="isRead"
    click-close
    is-time
    />
  <rir-input
    v-else-if="field.dataType === 'int'"
    :label="field.name"
    v-model="field.value"
    :params-input="{ type: 'number' }"
    :readonly="isRead"
  />
  <rir-checkbox
      v-else-if="field.dataType === 'boolean'"
      :label="field.name"
      v-model="field.value"
      :readonly="isRead"
    />

</template>

<script>
export default {
  name: 'event-field-type',
  props: {
    field: {
      type: Object
    },
    isRead: {
      type: Boolean
    }
  }
}
</script>
